<template>
  <div class="electronicFence">
    <div class="hcollapse">
      <el-card>
        <el-collapse v-model="activeCollapse">
          <el-collapse-item name="1" title="区域列表">
            <div class="collapseItem">
              <h-table
                ref="tableRef"
                v-model:columns="columns"
                :method="maparealist"
                :params="params"
                @row-click="rowClick"
                @handleClick="handleClick"
              >
                <template #dispositionStatus="{ row }">
                  {{ row.dispositionStatus || "未布控" }}
                </template>
              </h-table>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-card>
    </div>
    <div class="Fence">
      <div @click="clickDrawArea">绘制区域</div>
      <div @click="remDraw">清除</div>
    </div>
    <my-map
      @drawArea="drawArea"
      ref="mymapRef"
      :showOperationPoint="true"
    ></my-map>
    <el-dialog width="20%" title="添加区域" v-model="dialogShow">
      <el-form ref="formRef" :rules="rules" :model="tableParams" size="small">
        <el-form-item label="区域名称" prop="areaName">
          <el-input
            v-model="tableParams.areaName"
            placeholder="区域名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <h-button type="primary" @click="mapareasaveAxios">保存</h-button>
        <h-button @click="dialogShow = false">取消</h-button>
      </template>
    </el-dialog>
    <el-dialog title="布控" v-model="flag" top="40px" width="90%">
      <el-container>
        <el-container>
          <firstStep
            :regionIdListData="regionIdListData"
            @eventFlag="hidden"
          ></firstStep>
        </el-container>
      </el-container>
    </el-dialog>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, ref, nextTick } from "vue";
import { ElMessage } from "element-plus";
import MyMap from "@/components/map/MyMap.vue";
import {
  maparealist,
  mapareasave,
  mapareaDelete,
  dispositioninfo,
} from "@/api/smartApplication/smartApplicationApi.js";
import util from "@util/js";
import { useRouter } from "vue-router";

import { queryRealVideoTree } from "@/api/videoControl/videoApi.js";
import handleCoordinates from "@/components/map/js/modular/handleCoordinates";
import firstStep from "@/views/monitorManagement/components/firstStep.vue";
export default defineComponent({
  components: { MyMap, firstStep },
  setup() {
    const state = reactive({
      flag: false,
      regionIdListData: [],
      dialogShow: false,
      rules: {
        areaName: [
          {
            required: true,
            message: "请输区域名称",
            trigger: "blur",
          },
        ],
      },
      tableParams: {
        // areaName: "",
        // deviceList: [],
        // areaScope: "",
        // createUserId: localStorage.getItem("userDeptId")
        // createTime: "2022-03-28"
      },
      params: {},
      columns: [
        { type: "selection", show: false },
        {
          label: "区域名称",
          prop: "areaName",
        },
        {
          label: "状态",
          slot: "dispositionStatus",
        },
        {
          type: "operate",
          label: "操作",
          width: "140px",
          operates: [
            { name: "布控", emitKey: "bk" },
            { name: "清除", emitKey: "clear" },
            { name: "删除", emitKey: "del", type: "danger" },
          ],
        },
      ],
      activeCollapse: "0",
      videoData: [],
      selectPoint: [],
      maparealistData: [],
      checkbox: [],
    });
    const mymapRef = ref(null);
    const tableRef = ref(null);
    const router = useRouter();
    const clickDrawArea = () => {
      mymapRef.value && mymapRef.value.clickDrawArea("Polygon");
    };
    const remDraw = () => {
      mymapRef.value && mymapRef.value.remDraw();
    };
    const { reversePoint, setVideoPoint } = handleCoordinates();
    const drawArea = (val) => {
      console.log(val);
      const changeValue = val[0].corrdinates[0].map((element) => {
        return reversePoint(element);
      });
      state.tableParams.areaScope = JSON.stringify(changeValue);
      console.log(changeValue, 66666);
      state.selectPoint = state.videoData.filter((item) => {
        if (
          util.isInsidePolygon(
            [parseFloat(item.longitude), parseFloat(item.latitude)],
            changeValue
          )
        ) {
          return item;
        }
      });
      state.tableParams.deviceList = state.selectPoint
        .map((item) => item.otherId)
        .join(",");
      state.dialogShow = true;
    };
    const mapareasaveAxios = async () => {
      const res = await mapareasave(state.tableParams);
      if (res.code === 0) {
        ElMessage({
          type: "success",
          message: "添加成功",
        });
        state.dialogShow = false;
        refreshTable();
        state.activeCollapse = "1";
      }
    };
    // 点击查询按钮
    const refreshTable = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 获取区域树中摄像头数据
    const queryRealVideoTreeAsync = async () => {
      const res = await queryRealVideoTree();
      state.videoData = res.cameraBaseDtls;
      setTimeout(() => {
        pointInfoArray(res.cameraBaseDtls);
      }, 300);
    };
    // 添加接口中数据点位
    const pointInfoArray = (list) => {
      const array = list.filter((item, index) => {
        if (item.longitude && item.latitude) {
          item.location = setVideoPoint([
            Number(item.longitude),
            Number(item.latitude),
          ]);
          return item;
        }
      });
      const newList = array.map((element, index) => {
        const pointInfo = {
          name: "",
          item: element,
          id: 1,
          type: 1,
          showType: 2,
          poiType: 3408,
          location: element.location,
          click: (e) => {
            nextTick(() => {
              state.mapDataItem = element;
            });
          },
        };
        pointInfo.id = index + 1;
        return pointInfo;
      });
      nextTick(() => {
        mymapRef.value && mymapRef.value.loadMarker(newList);
      });
    };
    queryRealVideoTreeAsync();
    const checkboxChange = (val) => {
      state.maparealistData.forEach((item) => {
        if (val.indexOf(item.areaId) !== -1) {
          mymapRef.value &&
            mymapRef.value.drawArea([JSON.parse(item.areaScope)]);
        }
      });
    };
    const bkClick = (row) => {
      console.log();
      router.push({
        path: "monitorManagement",
        query: {
          deviceArray: row.deviceList.split(","),
        },
      });
      // state.regionIdListData = row.deviceList.split(",");
    };

    const handleClick = ({ emitKey }, row) => {
      if (emitKey === "bk") {
        bkClick(row);
      } else if (emitKey === "del") {
        delClick(row);
      } else if (emitKey === "clear") {
        mymapRef.value && mymapRef.value.clearArea();
      }
    };
    const rowClick = (row) => {
      mymapRef.value && mymapRef.value.clearArea();
      setTimeout(() => {
        mymapRef.value &&
          mymapRef.value.drawArea(
            [JSON.parse(row.areaScope)],
            "rgba( 255, 0, 0, 0.2)"
          );
      }, 100);
    };
    const delClick = async (row) => {
      // const params = {
      //   areaIds: [row.areaId],
      // };
      const res = await mapareaDelete([row.areaId]);
      if (res.code == 0) {
        ElMessage.success("删除成功");
        refreshTable();
      }
    };
    return {
      ...toRefs(state),
      tableRef,
      checkboxChange,
      mapareasaveAxios,
      maparealist,
      drawArea,
      clickDrawArea,
      remDraw,
      mymapRef,
      handleClick,
      rowClick,
    };
  },
});
</script>
<style scoped lang="scss">
.electronicFence {
  position: relative;
  .hcollapse {
    position: absolute;
    top: 10px;
    left: 50px;
    z-index: 10;
    width: 500px;
    :deep(.el-collapse-item__header) {
      // background: red;
      border: 1px solid rgba(0, 0, 0, 0.09);
      border-radius: 5px;
      padding-left: 20px;
    }
    :deep(.el-collapse-item__content) {
      padding-bottom: 0px;
    }
    .collapseItem {
      height: 315px;
      padding: 10px;
      :deep(.hz-table) {
        height: 100%;
      }
    }
  }
  .Fence {
    position: absolute;
    top: 10px;
    right: 50px;
    z-index: 10;
    cursor: pointer;
    color: #1887ff;
    overflow: hidden;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 10px 0 #c9c9c9;
    padding: 10px 20px;
    display: flex;
    div {
      margin: 0 20px;
    }
  }
}
</style>
